import { render, staticRenderFns } from "./StatusChip.vue?vue&type=template&id=75ef1dbc"
import script from "./StatusChip.vue?vue&type=script&lang=js"
export * from "./StatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75ef1dbc')) {
      api.createRecord('75ef1dbc', component.options)
    } else {
      api.reload('75ef1dbc', component.options)
    }
    module.hot.accept("./StatusChip.vue?vue&type=template&id=75ef1dbc", function () {
      api.rerender('75ef1dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/StatusChip.vue"
export default component.exports